var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9696 34.9652L67.9676 16.7817C67.6959 14.2806 65.7127 12.3163 63.218 12.0637L45.0408 10.03C43.4175 9.85948 41.807 10.4215 40.6386 11.5647L11.5665 40.6685C9.47589 42.7653 9.47589 46.1507 11.5665 48.2413L31.7521 68.4269C32.75 69.4374 34.1142 70.0059 35.5353 69.9995C36.9564 70.0185 38.327 69.4501 39.3185 68.4269L68.4349 39.3547C69.5845 38.1989 70.1465 36.582 69.9696 34.9652ZM60.8242 24.2471C59.4348 25.6303 57.1863 25.6303 55.7968 24.2471C54.3947 22.8576 54.3884 20.5965 55.7715 19.1944C57.161 17.7985 59.4221 17.7859 60.8242 19.1754C62.22 20.5839 62.22 22.8449 60.8242 24.2471Z",
    fill: "url(#paint0_linear_322_3462)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_322_3462",
    x1: 12.3658,
    y1: 1.72495,
    x2: 70.4842,
    y2: 65.4173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1075FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/Step3.93399e3bd5f9baee3ec4dec7505bef25.svg";
export { ForwardRef as ReactComponent };